import React from 'react';

const SegmentIcon = ({ segment, small }) => (
  <span
    style={{
      display: 'inline-block',
      borderRadius: small ? 2 : 4,
      height: small ? 10 : 14,
      width: small ? 10 : 25,
      marginRight: small ? '2px' : '.5em',
      backgroundColor: segment.color,
    }}
  />
);

export default SegmentIcon;
